import React, { useCallback, useRef, useState } from 'react'
import ModalWithScroll from '../ModalWithScroll/ModalWithScroll'
import ReactMarkdown from 'react-markdown'
import PageTitle from '../PageTitle/PageTitle'
import { ButtonsContainer, TosContent } from './styles'
import { Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { tosText } from '../../docs/prop-ai-tos'

type TermsProps = {
	show: boolean
	accept(): void
}

export default function Terms({ show, accept }: TermsProps) {
	const { t } = useTranslation()
	const tosContentRef = useRef<HTMLDivElement | null>(null)
	const [isAcceptEnabled, setIsAcceptEnabled] = useState(false)

	const handleScroll = useCallback(() => {
		const tosContent = tosContentRef.current

		// Adding a tolerance value to handle potential floating point issues
		const tolerance = 5
		const isScrolledToBottom =
			tosContent &&
			Math.ceil(tosContent.scrollTop + tosContent.clientHeight) >= tosContent.scrollHeight - tolerance

		if (isScrolledToBottom) {
			setIsAcceptEnabled(true)
		}
	}, [tosContentRef])

	return (
		<ModalWithScroll show={show}>
			<PageTitle>{t('terms_of_service.title')}</PageTitle>
			<TosContent ref={tosContentRef} onScroll={handleScroll}>
				<ReactMarkdown>{tosText}</ReactMarkdown>
			</TosContent>
			<ButtonsContainer>
				<Button
					variant="contained"
					onClick={accept}
					disabled={!isAcceptEnabled}
					fullWidth={false}
					sx={{
						minWidth: { xs: '120px', sm: '150px' },
						fontSize: { xs: '0.875rem', sm: '1rem' },
					}}
				>
					{t('terms_of_service.accept_button')}
				</Button>
			</ButtonsContainer>
		</ModalWithScroll>
	)
}
